import { useSiteBooleanAttributes } from 'hooks/useAttribute';
import { ReactElement } from 'react';
import {
  FaCalendarAlt,
  FaUserCheck,
  FaUserClock,
  FaUserCog,
} from 'react-icons/fa';
import {
  PATIENT_BOOKING_ROUTE,
  PATIENT_CHECK_IN_ROUTE,
  patientURL,
} from 'routes/AppRoutes';
import { DashboardLink, DashboardWrapper } from './Dashboard.styled';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { DISABLE_SELF_CHECK_IN } from '../../../../configs/siteAndTrustAttributes';

export const PatientDashboard = (): ReactElement => {
  const { t } = useCommonTranslation();
  const [hideSelfCheckIn] = useSiteBooleanAttributes(DISABLE_SELF_CHECK_IN);

  return (
    <DashboardWrapper data-testid="dashboard">
      {!hideSelfCheckIn && (
        <DashboardLink to={PATIENT_CHECK_IN_ROUTE} key={'check-in'}>
          <FaUserCheck className="dashboard-icon" />
          {t('self-check-in')}
        </DashboardLink>
      )}
      <DashboardLink to={PATIENT_BOOKING_ROUTE} key={'booking'}>
        <FaCalendarAlt className="dashboard-icon" />
        {t('book-an-appointment')}
      </DashboardLink>
      <DashboardLink
        to={`${patientURL}/my-appointments`}
        key={'my-appointments'}
      >
        <FaUserClock className="dashboard-icon" />
        {t('my-appointments')}
      </DashboardLink>
      <DashboardLink to={`${patientURL}/shared-accounts`} key={'profile'}>
        <FaUserCog className="dashboard-icon" />
        {t('profile-and-family')}
      </DashboardLink>
    </DashboardWrapper>
  );
};
